<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <div v-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        label="Título da lista *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        label="Descrição da lista"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo texto</span>
    </div>

    <div v-if="tipoIdPaiLocale !== 7 && tipoIdPaiLocale !== 8">
      <v-textarea
        v-model="nodeDataLocale.textoSelecao"
        label="Mensagem *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required]"
        @change="nodeConfig"
      />
    </div>

    <v-textarea
      v-model="nodeDataLocale.chatGptAssistantKey"
      label="Chave do Assistente *"
      placeholder="Chave"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      class="mt-2"
      @change="nodeConfig"
    />

    <v-textarea
      v-model="nodeDataLocale.chatGptApiKey"
      label="Chave da API *"
      placeholder="Chave"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      class="mt-2"
      @change="nodeConfig"
    />

    <v-select
      v-model="nodeDataLocale.filaId"
      :items="filas"
      item-text="nome"
      item-value="id"
      class="mt-2"
      label="Selecione uma fila"
      no-data-text="Nenhuma fila encontrada"
      outlined
      clearable
      @change="nodeConfig"
    ></v-select>
  </div>
</template>

<script>
import { inject, ref, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import FilaService from '@/services/modules/FilaService'

export default {
  setup(props, { emit }) {
    const filas = ref([])

    async function loadFilas() {
      try {
        filas.value = await FilaService.getFilasCanalTipoBot()
      } catch (error) {
        console.error('Erro ao carregar filas:', error)
      }
    }

    loadFilas()

    const opcoes = ref([])
    function exibirOpcoesDoNo(data) {
      let concat = ''
      if (data.chatBotNoTipoId === 1) {
        if (data.nosFilhos.length > 0) {
          data.nosFilhos.forEach(element => {
            concat += `${element.numero} - ${element.texto}\n`
          })
        }
      }
      opcoes.value = concat
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    watch(() => nodeData.value, value => {
      nodeDataLocale.value = value
      exibirOpcoesDoNo(value)
    }, { immediate: true, deep: true })

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')
    watch(() => tipoIdPai.value, value => {
      tipoIdPaiLocale.value = value
    }, { immediate: true, deep: true })

    function nodeConfig() {
      emit('node-config')
    }

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      filas,  // Adiciona filas aqui
      opcoes,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>